const { Component } = require('react')

class MobileOption extends Component {
  render () {
    return (
      <label className='mobile-option'>
        <input type='radio' name={this.props.name} value={this.props.value} defaultChecked={this.props.defaultChecked} onClick={this.props.onClick} />
        <div>
          <span className='mobile-option__text'>{this.props.text}</span>
          {this.props.secondText ? <span className='mobile-option__secondText'>{this.props.secondText}</span> : null}
        </div>
      </label>
    )
  }
}

module.exports = MobileOption
